module.exports = __webpack_public_path__ + "media/images/image-1-0169a20f.jpg";